<template>
  <div
    id="ManagementPanel"
    class="cardRole"
    :class="{ active: view, close: !view }"
  >
    <div class="mdl-grid">
      <div
        class="mdl-cell mdl-cell--1-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
      >
        <span class="material-icons closePanel" @click="closePanel()"
          >close</span
        >
      </div>
      <div
        class="mdl-cell mdl-cell--11-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
      >
        <h3 v-if="form.id">{{ $t("group.titleEditGroup") }} {{ form.name }}</h3>
        <h3 v-else>{{ $t("group.titleNewRole") }}</h3>

        <p class="subTitle">{{ $t("group.subTitleNewRole") }}</p>

        <div class="mdl-grid noMargin">
          <div class="mdl-cell mdl-cell--12-col">
            <div class="cdl-input" style="margin: 0; margin-top: 20px">
              <input
                type="text"
                name="name"
                v-model="form.name"
                @input="label($event)"
              />
              <label>{{ $t("group.nameRole") }}*</label>
              <span
                class="error"
                v-if="this.v$.form.name.$invalid && this.v$.form.name.$dirty"
              >
                {{ $t("group.nameRole") }} {{ $t("checkCoverage.isRequired") }}
              </span>
              <span
                class="error"
                v-if="duplicateName"
              >
                {{ $t("group.duplicateNameError") }}
              </span>
            </div>
            <div class="space"></div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <hr />
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <span class="labelTwo">{{ $t("group.sectionOne") }}*</span><br />
            <span
              class="error"
              v-if="
                this.v$.form.pages.$invalid &&
                this.v$.form.pages.$dirty
              "
            >
              {{ $t("group.sectionOneError") }}
            </span>
          </div>
          <div class="mdl-cell mdl-cell--12-col">

            <!-- NUOVO STATICO -->
            <div v-for="(page, keyPermissions) in menu"
              :key="keyPermissions">
                <div :class="['groupIndex-' + keyPermissions]">

                  <div class="itemGroup"
                    @click="openChild($event, 'p-' + keyPermissions)"
                    v-if="getPermissionForPartner(page.permissions, 'gestione_clienti_finali,verifica_copertura') && getPermissionForDirectUser(page.permissions, true)">
                    <span class="material-icons arrow"
                          :class="[
                            'arrowPanel-p-' + keyPermissions,
                            page.child ? '' : 'opacity',
                            form.id ? 'rotate' : '',
                          ]">arrow_right</span>
                    <span class="boxCheck" @click="
                                  setPermission(
                                    page.permissions, keyPermissions
                                  )
                                ">
                      <span class="material-icons iconCheck"
                            :value="page.permissions"
                            :class="[
                              page.permissions,
                              'iconCheck-' + keyPermissions,
                              checkBox(page.permissions) ? 'active' : '',
                            ]"
                            >check</span>
                    </span>
                    <span class="firstUpper">{{ $t(page.label) }}</span>
                  </div> <!-- CHIUSURA itemGroup -->
                  <div class="contentSubElems child" v-for="(levelOne, keylevelOne) in page.child"
                  :key="keylevelOne"
                      :class="[
                        'child-p-' + keyPermissions,
                        form.id ? 'active' : '',,
                      ]">
                    <div class="block" v-if="getPermissionForDirectUser(levelOne.permissions, levelOne.child && levelOne.child.length > 0)">
                      <div class="border"></div>
                      <div> <!-- APERTURA A -->
                        <div class="itemGroup"
                            @click="openChild($event, 'p-'+ keyPermissions + '-' + keylevelOne)">
                          <span
                            class="material-icons arrow"
                            :class="[
                              'arrowPanel-p-' + keyPermissions + '-' + keylevelOne,
                              levelOne.child ? '' : 'opacity',
                              form.id ? 'rotate' : '',
                            ]"
                            >arrow_right</span>
                          <span class="boxCheck"
                                @click="
                                  setPermission(
                                    levelOne.permissions, keyPermissions + '-' + keylevelOne
                                  )
                                ">
                            <span
                            class="material-icons iconCheck"
                            :value="levelOne.permissions"
                            :class="[
                              levelOne.permissions,
                              'iconCheck-'+ keyPermissions,
                              'iconCheck-'+ keyPermissions + '-' + keylevelOne,
                              checkBox(levelOne.permissions) ? 'active' : '',
                            ]"
                            >check</span>
                          </span>
                          <span class="firstUpper">{{ $t(levelOne.label) }}</span>
                        </div>
                      <div class="childChild" v-for="(levelTwo, keylevelTwo) in levelOne.child"
                        :key="keylevelTwo"
                        :class="[
                          'child-p-' + keyPermissions + '-' + keylevelOne,
                          form.id ? 'active' : '',
                        ]"
                      > <!-- APERTURA childChild -->
                        <div class="contentSubElems">
                          <div class="block" v-if="getPermissionForDirectUser(levelTwo.permissions, levelTwo.child && levelTwo.child.length > 0)">
                            <div class="borderUnion"></div>

                            <div
                              class="itemGroup"
                              @click="
                                openChild(
                                  $event,
                                  'p-'+ keyPermissions + '-' + keylevelOne + '-' + keylevelTwo
                                )">
                                <span
                                class="material-icons arrow"
                                :class="[
                                  'arrowPanel-p-'+ keyPermissions + '-' + keylevelOne + '-' + keylevelTwo,
                                  levelTwo.child ? '' : 'opacity',
                                ]"
                                >arrow_right</span>

                                <span
                                class="boxCheck"
                                @click="
                                  setPermission(
                                    levelTwo.permissions, keyPermissions + '-' + keylevelOne + '-'  + keylevelTwo
                                  )
                                "
                                ><span
                                  class="material-icons iconCheck"
                                  :value="levelTwo.permissions"
                                  :class="[
                                    levelTwo.permissions,
                                    'iconCheck-' + keyPermissions,
                                    'iconCheck-' + keyPermissions + '-' + keylevelOne,
                                    'iconCheck-' + keyPermissions + '-' + keylevelOne + '-' + keylevelTwo,
                                    checkBox(levelTwo.permissions) ? 'active' : '',
                                  ]"
                                  >check</span
                                >
                              </span>
                              <span class="firstUpper">{{ $t(levelTwo.label) }}</span>
                            </div>

                          </div> <!-- CHIUSURA block -->

                          <div
                            v-for="(levelThree, keylevelThree) in levelTwo.child"
                            :key="keylevelThree"
                            class="childChildPage"
                            :class="[
                              'child-p-' +
                                keyPermissions +
                                '-' +
                                keylevelOne +
                                '-' +
                                keylevelTwo,
                              form.id ? 'active' : '',
                            ]"
                          >
                            <div class="contentSubElems">
                              <div class="block" v-if="getPermissionForDirectUser(levelThree.permissions)">
                                <div class="borderUnion"></div>
                                <div class="itemGroup">
                                  <span
                                    v-if="true"
                                    class="boxCheck"
                                    @click="
                                      setPermission(
                                        levelThree.permissions,
                                        keyPermissions +
                                          '-' +
                                          keylevelOne +
                                          '-' +
                                          keylevelTwo +
                                          '-' +
                                          keylevelThree
                                      )
                                    "
                                    ><span
                                      class="material-icons iconCheck"
                                      :value="levelThree.permissions"
                                      :class="[
                                        'iconCheck-' + keyPermissions,
                                        'iconCheck-' +
                                          keyPermissions +
                                          '-' +
                                          keylevelOne,
                                        'iconCheck-' +
                                          keyPermissions +
                                          '-' +
                                          keylevelOne +
                                          '-' +
                                          keylevelTwo,
                                        'iconCheck-' +
                                          keyPermissions +
                                          '-' +
                                          keylevelOne +
                                          '-' +
                                          keylevelTwo +
                                          '-' +
                                          keylevelThree,
                                        checkBox(levelThree.permissions)
                                          ? 'active'
                                          : '',
                                      ]"
                                      >check</span
                                    >
                                  </span>
                                  <span v-else class="boxCheck" style="cursor: no-drop;" v-tooltip="'Non puoi assegnare quest&rsquo;area'"></span>
                                  <span class="firstUpper">{{
                                    $t(levelThree.label)
                                  }}</span>
                                </div>
                              </div>
                            </div> <!-- CHIUSURA contentSubElems -->
                          </div> <!-- CHIUSURA childChildPage -->
                        </div> <!-- CHIUSURA contentSubElems -->
                      </div> <!-- CHIUSURA childChild -->
                      </div> <!-- CHIUSURA A -->
                    </div> <!-- CHIUSURA block -->
                  </div> <!-- CHIUSURA contentSubElems -->
                </div> <!-- CHIUSURA groupIndex-i -->
            </div> <!-- CHIUSURA STATICO -->

            <br /><br />

          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <div class="space"></div>
            <hr />
            <div class="space"></div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <span class="labelTwo">{{ $t("group.sectionTwo") }}*</span><br />
            <span
              class="error"
              v-if="this.v$.form.color.$invalid && this.v$.form.color.$dirty"
            >
              {{ $t("group.colorGroupRequired") }}
              {{ $t("checkCoverage.isRequired") }}
            </span>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <div class="contentColorRole">
              <div
                v-for="(color, keyC) in colors"
                class="colorRole"
                :class="['color-' + color]"
                @click="setColor($event, color)"
                :key="keyC"
              ></div>
            </div>
            <input type="hidden" v-model="form.color" />
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <div class="space"></div>
            <hr />
            <div class="space"></div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <span class="labelTwo">{{ $t("group.sectionThree") }}</span>
            <p class="subSectionTwo" v-if="false">{{ $t("group.subSectionThree") }}</p>
            <br /><br />
          </div>
          <div
            class="mdl-cell mdl-cell--12-col contentUsersSearch"
            v-if="form.users && form.users.length > 0"
          >
            <div
              v-for="(user, index) in form.users"
              :key="index"
              class="singleUser view active"
              :class="['user-' + index]"
            >
              <div>{{ user.first_name }} {{ user.last_name }}</div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <div class="contentButton">
              <button class="cdlButton" @click="searchUsers()" style="width: 100%;">
                {{ $t("group.searchUser") }}
              </button>
            </div>
            <div class="space"></div>
            <hr />
            <div class="space"></div>
            <div class="contentButton">
              <button class="cdlButtonGreen" @click="submit" id="submitRole">
                {{
                  form.id
                    ? $t("group.subTitleEditGroup")
                    : $t("group.saveNewRole")
                }}
              </button>
              <div v-if="formError" class="error" style="margin-top:10px;">
                {{ formError }}
              </div>
            </div>
            <p class="cancel" @click="closePanel()">{{ $t("users.cancel") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import "@/assets/scss/ManagementPanel.scss";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useUserStore } from "@/stores/UserStore";
import menuJson from "@/configs/menu.json";
import { ctrlPermissions } from "@/services/Permissions";

export default {
  name: "MyManagementRole",
  props: {
    view: {
      type: Boolean,
      required: true,
    },
    singleGroup: {
      type: Object,
      required: true,
    },
    // groups:{
    //   type: Object,
    //   required: true,
    // },
    usersGroup: {
      type: Array,
      default: () => []
    },
    userLogged: {
      type: Object,
      required: true,
    },
    pages: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        name: { required },
        color: { required },
        pages: { required },
      },
    };
  },
  data() {
    return {
      form: {
        id: null,
        name: null,
        color: "",
        pages: [],
        users: [],
      },
      permissions: null,
      colors: [
        "a8eec1",
        "fb8873",
        "fae29f",
        "6ed7d3",
        "cfd6de",
        "6585a7",
        "5f6b7a",
        "1b655e",
        "8c6d1f",
      ],
      ctrl: false,
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      menu: {},
      duplicateName: false,
      formError: ""
    };
  },
  mounted() {

    const userStore = useUserStore()
    const permissions = Object.values(userStore.permissions)
    
    const filterMenu = (menu) => {
      return menu
        .map(element => {
          const children = element.child && element.child.length > 0
            ? filterMenu(element.child)
            : []

          const hasPermission = element.permissions
            ? element.permissions.some(p => permissions.includes(p))
            : true
          if (element.always_visible || hasPermission || children.length > 0) {
            return {
              ...element,
              child: children
            }
          }

          return null
        })
    .filter(Boolean)
    }

    this.menu = filterMenu(menuJson)
    console.log(this.menu)
  },
  methods: {
    closePanel(whoUpdate = 0) {
      this.ctrl = false;
      this.$emit("close-panel", { whichPanel: 1, whoUpdate: whoUpdate });
    },
    label(ev) {
      this.$LabelInput(ev);
    },
    searchUsers() {
      this.$emit("open-users-group");
    },
    checkBox(check) {
      if( typeof check == 'object' ) {
        return check.every((element) => this.form.pages.includes(element));
      }
      return this.form.pages.find((element) => element == check);
    },
    setColor(ev, color) {
      let colorsDiv = document.getElementsByClassName("colorRole");
      for (let i = 0; i < colorsDiv.length; i++) {
        if (i != 0) {
          colorsDiv[i].classList.remove("active");
        }
      }
      ev.srcElement.classList.add("active");

      this.form.color = color;
    },
    openChild(ev, index, levelOne = "", levelTwo = "") {
      if (
        !ev.srcElement.classList.contains("boxCheck") &&
        !ev.srcElement.classList.contains("iconCheck")
      ) {
        if (typeof levelOne != "string") {
          levelOne = "-" + levelOne;
          if (typeof levelTwo != "string") {
            levelOne += "-" + levelTwo;
          }
        }
        if (document.getElementsByClassName("child-" + index)[0]) {
          if (
            document
              .getElementsByClassName("child-" + index + levelOne)[0]
              .classList.contains("active")
          ) {
            let elms = document.getElementsByClassName(
              "child-" + index + levelOne
            );
            for (let i = 0; i < elms.length; i++) {
              elms[i].classList.remove("active");
            }
            document
              .getElementsByClassName("arrowPanel-" + index + levelOne)[0]
              .classList.remove("rotate");
          } else {
            let elms = document.getElementsByClassName(
              "child-" + index + levelOne
            );
            for (let i = 0; i < elms.length; i++) {
              elms[i].classList.add("active");
            }
            document
              .getElementsByClassName("arrowPanel-" + index + levelOne)[0]
              .classList.add("rotate");
          }
        }
      }
    },
    setPermission(permission, key, ctrl = 0) {

      // Only add permissions that the user actually has access to
      permission.forEach(elm => {
        // Check if user has this permission by looking in their available pages

        const userHasPermission = this.pages.some(page =>
          page.name && page.name.toLowerCase() === elm.toLowerCase()
        );

        if (userHasPermission && !this.form.pages.includes(elm)) {
          this.form.pages.push(elm);
        }
      });

      let elm = document.getElementsByClassName("iconCheck-" + key)[0];

      // Se quello che ho cliccato è attivo, rimuovo e tolgo tutto quello che c'è dopo
      if (elm.classList.contains("active")) {
       elm.classList.remove("active");
       this.form.pages = this.form.pages.filter(page => !permission.includes(page));
       let elms = document.getElementsByClassName("iconCheck-" + key);
       if (elms.length > 1) {
         for (let i = 1; i < elms.length; i++) {
           let namePerm = document
             .getElementsByClassName("iconCheck-" + key)
             [i].getAttribute("value");
           let index = this.form.pages.indexOf(namePerm);
           if (index > -1) {
             document
               .getElementsByClassName("iconCheck-" + key)
               [i].classList.remove("active");
           }
         }
       }

        // Rimuovo i check padri
        if (key.toString().includes("-")) {
          let is = key.split("-");
          let chekIndex = "";
          is.forEach((singleKey, i) => {
            if( is.length -1 == i ) {
              return;
            }

            chekIndex += "-" + singleKey;
            document.getElementsByClassName("iconCheck" + chekIndex)[0].classList.remove("active");

          });
        }

      } else {
        elm.classList.add("active");
        let elms = document.getElementsByClassName("iconCheck-" + key);
        if (elms.length > 1) {
          for (let i = 1; i < elms.length; i++) {
            let namePerm = document
              .getElementsByClassName("iconCheck-" + key)
              [i].getAttribute("value");
            document
              .getElementsByClassName("iconCheck-" + key)
              [i].classList.add("active");
          }
        }

        // Rimuovo i check padri (se non ho cliccato un padre)
        if (key.toString().includes("-")) {
          let is = key.split("-");
          if( is.length > 1 ) {
            // Non è padre
            is.forEach((singleKey, i) => {
              if( i == 0 ) {
                setTimeout(() => {
                document.getElementsByClassName("iconCheck-" + singleKey)[i].classList.remove("active");

                }, 100);
              }
            });
          }
        }

      }

      return true;
    },
    build() {

      Object.assign(this.form, this.singleGroup);

      // Prefer incoming prop usersGroup for immediate UI, then fetch and merge full role membership
      if (Array.isArray(this.usersGroup) && this.usersGroup.length > 0) {
        this.form.users = this.usersGroup;
      }
      this.getUsers();

      // Trigger label
      let allInputs = document.getElementsByTagName("input");
      setTimeout(() => {
        for (let i = 0; i < allInputs.length; i++) {
          if (allInputs[i].value != "") {
            allInputs[i].classList.add("not-empty");
          }
        }
      }, 300);

      // Set color role
      let colorsDiv = document.getElementsByClassName("colorRole");
      for (let i = 0; i < colorsDiv.length; i++) {
        colorsDiv[i].classList.remove("active");
        if (
          this.form.id != null &&
          colorsDiv[i].classList.contains("color-" + this.form.color.toLowerCase())
        ) {
          colorsDiv[i].classList.add("active");
        }
      }

      // But what the fuck are you giving me an array of objects if you want a fucking array of strings?
      let pages = [];
      this.form.pages.forEach(page => {
        // Only include pages that are selectable (can be modified by user)
        if (page.selectable === true) {
          pages.push(page.name);
        }
      });

      this.form.pages = pages;


    },

    getPermissionForPartner( page, permission ) {
      let perms = permission.split(",");
      let pageString = page.toString();
      let userInfo = useUserStore();
      perms.forEach(e => {
        let isPage = pageString.search(e) > -1 ? true : false;
        if( !userInfo.user.is_partner && isPage) {
          return false;
        }
      });
      return true;
    },
    getPermissionForDirectUser( page, isParentContainer = false ) {
      let listReturn = [];
      page.forEach(e => {
        listReturn.push(this.pages.some(item =>
            item.name && item.name.toLowerCase().includes(e.toLowerCase())
        ));
      });

      if (isParentContainer) {
        // For parent containers: show if user has ANY of the required permissions
        return listReturn.some(value => value === true);
      } else {
        // For leaf items: show only if user has ALL required permissions
        return listReturn.every(value => value === true);
      }
    },
    getUsers() {

      if( !this.form.id ) {
        this.form.users = Array.isArray(this.usersGroup) ? this.usersGroup : [];
        return;
      }

      // If we already have an in-memory selection (coming from SearchUser), prefer it and avoid API jitter
      if (Array.isArray(this.usersGroup) && this.usersGroup.length > 0) {
        this.form.users = this.usersGroup;
        return;
      }

      let he = {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      };

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL + "users/v2/role/" + this.form.id + "/users?page_number=1&disable_pagination=true",
          { headers: he }
        )
        .then((response) => {
          this.form.users = response.data.items;
        });
    },

    handleRoleSaveError(err) {
      console.error(err);
      this.viewLoader = true;
      if (err && err.response && err.response.status === 400) {
        this.duplicateName = true;
        this.formError = this.$t ? this.$t("group.duplicateNameError") : "Duplicate role name";
      } else {
        this.formError = this.$t ? this.$t("group.saveError") : "Unable to save role. Please try again.";
      }
    },

    async submit() {
      const result = await this.v$.$validate();
      if (result) {
        this.v$.$reset();
        this.viewLoader = false;

        // Reset previous errors
        this.duplicateName = false;
        this.formError = "";

        // Client-side validation: prevent duplicate role names (case-insensitive, trimmed)
        try {
          const resp = await this.axios.get(
            window.VUE_APP_MISTRA_URL + "users/v2/role?page_number=1&disable_pagination=true",
            { headers: this.he }
          );
          const roles = (resp && resp.data && (resp.data.items || resp.data)) || [];
          const newName = (this.form.name || "").trim().toLowerCase();
          const isDuplicate = roles.some(r => r && r.name && r.name.trim().toLowerCase() === newName && (!this.form.id || r.id !== this.form.id));
          if (isDuplicate) {
            this.duplicateName = true;
            this.formError = this.$t ? this.$t("group.duplicateNameError") : "A role with this name already exists";
            this.viewLoader = true;
            return;
          }
        } catch (e) {
          // If roles list cannot be loaded, proceed and rely on backend to validate
          console.warn('Unable to validate duplicate name on client. Proceeding to save.', e);
        }

        // Normalize and deduplicate pages before sending (remove non-selectable like 'dashboard')
        this.form.pages = Array.from(new Set(this.form.pages.filter(page => page && page !== 'dashboard')));

        let saveRole = new Promise((resolve) => {
          if (this.form.id) {
            this.axios
              .put(
                window.VUE_APP_MISTRA_URL +
                  "users/v2/role/" +
                  this.form.id,
                this.form,
                { headers: this.he }
              )
              .then(() => {
                resolve(true);
              })
              .catch((err) => {
                this.handleRoleSaveError(err);
                resolve(false);
              });
          } else {
            this.axios
              .post(
                window.VUE_APP_MISTRA_URL +
                  "users/v2/role",
                this.form,
                { headers: this.he }
              )
              .then((rls) => {
                this.form.id = rls.data.id;
                resolve(true);
              })
              .catch((err) => {
                this.handleRoleSaveError(err);
                resolve(false);
              });
          }
        });

        Promise.all([saveRole]).then((values) => {
          if (values[0]) {
            let reload = false;

            let users_id = {
              users: [],
            };

            if (this.form.users && this.form.users.length > 0) {
              this.form.users.forEach((elm) => {
                users_id.users.push(elm.id);
                if (this.userLogged.email == elm.email) {
                  reload = true;
                }
              });

              this.axios.post(
                window.VUE_APP_MISTRA_URL +
                  "users/v2/role/" +
                  this.form.id +
                  "/users",
                users_id,
                { headers: this.he }
              );
            }

            if (reload) {
              location.reload();
            }

            this.$emit("reset-users-group");

            this.viewLoader = true;
            this.closePanel(2);
          }
        });

      }

    },
    reset() {
        let allChecks = document.getElementsByClassName("iconCheck");
        for (let i = 0; i < allChecks.length; i++) {
          if (allChecks[i].classList.contains("active") ) {
            allChecks[i].classList.remove("active");
          }
        }

        let allColors = document.getElementsByClassName("colorRole");
        for (let i = 0; i < allColors.length; i++) {
          if (allColors[i].classList.contains("active") ) {
            allColors[i].classList.remove("active");
          }
        }

        this.form = {
                      id: null,
                      name: null,
                      color: "",
                      pages: [],
                      users: [],
                    };
    }
  },
  watch: {
    view(newValue) {
      const div = document.querySelector("#ManagementPanel");
      div.scrollTo(0, 0);
      if( newValue && !this.singleGroup.id ) {
        this.reset()
      }
      else {
        this.build();
      }
    },
    usersGroup: {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.form.users = newVal;
        } else if (!newVal) {
          this.form.users = [];
        }
      },
      deep: true,
    }
  },
  activated() {
    if( this.usersGroup.length > 0 ) {
      this.form.users = this.usersGroup;
    }

    if( this.singleGroup.id ) {
      this.build();
    }
  }
};
</script>
